import React from "react";
import { Modal, Row, Col, Typography, Button, Divider } from "antd";
import { useHistory } from "react-router-dom";
import {PERMISSIONS} from "constants/permissions";
import Can from "../../../casl/Can"
const { Title, Text } = Typography;

export default function ProductIDModal({
  isModalVisible,
  handleOk,
  handleCancel,
  productFound,
}) {
  const history = useHistory();
  return (
    <Modal
      visible={isModalVisible}
      onOk={handleOk}
      onCancel={handleCancel}
      footer={null}
      // width={"81em"}

      centered
    
    >
      <Title
        level={4}
      >{` ${productFound.length} products have the same ID`}</Title>
      <Row style={{ maxHeight: "40em", overflowY: "auto", marginTop: "2em" }}>
        <Col span={24}>
          <Row>
            {productFound.map((product, index) => (
              <Col span={24}>
                <Row>
                  <Col span={12}>
                    <img
                      src={`${process.env.REACT_APP_DIRECTUS}assets/${product?.product_images?.[0]?.directus_files_id}?transforms=[["resize",{"width":190,"height":160,"fit":"contain","background":{"r":242,"g":242,"b":242}}]]`}
                      // src={`${process.env.REACT_APP_CLOUDINARY}/b_rgb:f2f2f2,c_pad,h_193,q_100,w_210/${product?.product_images?.directus_files_id}`}
                      // onError={(e) => {
                      //   e.target.onerror = null;
                      //   e.target.src = `${process.env.REACT_APP_DIRECTUS}assets/${product?.product_images?.directus_files_id}?transforms=[["resize",{"width":210,"height":193,"fit":"contain","background":{"r":242,"g":242,"b":242}}]]`;
                      // }}
                      alt={"something"}
                      key={index}
                      style={{ borderRadius: 8 }}
                    />
                  </Col>

                  <Col
                    span={9}
                    style={{
                      display: "flex",
                      flexDirection: "column",
                      justifyContent: "space-between",
                    }}
                  >
                    <Row justify="space-between">
                      <Col>
                        <Row>
                          <Text type="secondary">Category</Text>
                        </Row>
                        <Row style={{ marginTop: "0.5em" }}>
                          <Title level={5}>
                            {product?.secondary_category?.name}
                          </Title>
                        </Row>
                      </Col>
                      <Col>
                        <Row>
                          <Text type="secondary">Product ID</Text>
                        </Row>
                        <Row style={{ marginTop: "0.5em" }}>
                          <Title level={5}>{product?.product_id}</Title>
                        </Row>
                      </Col>
                    </Row>
                    {/* <Row>
                    <Can 
                      I={PERMISSIONS.update_products.slug}
                      a={PERMISSIONS.update_products.permissionType}
                      >
                    <Button
                        style={{
                          backgroundColor: "#F0F8F6",
                          border: "1px solid #0B7764",
                        }}
                        onClick={() =>{
                          handleCancel();
                          history.push(`/edit-product/${product?.id}`);
                         
                        }
                        }
                      >
                        Edit
                      </Button>
                    </Can>
                    </Row> */}
                  </Col>
                </Row>
               {
                  index !== productFound.length - 1 ? <Divider /> : null
               }
              </Col>
            ))}
          </Row>
        </Col>
      </Row>
    </Modal>
  );
}
